import { AUTH_SUCCESS, AUTH_FAILED, AUTH_STARTED } from "../actions/authAction";
import { setFetchSuccess, setFetchFailed, setFetchIsFetching, setFetchUninitiated } from "../loadingStates";

const initialState = {
  ...setFetchUninitiated()
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_STARTED:
      return {
        ...state,
        ...setFetchIsFetching()
      };
    case AUTH_SUCCESS:
      console.log("auth success", action);
      return {
        ...state,
        ...setFetchSuccess(),
        callbackUrl: action.json.successUrl,
        token: action.json.tokenId,
        receivedAt: action.receivedAt
      };
    case AUTH_FAILED:
      return {
        ...state,
        ...setFetchFailed(action.error)
      };
    default:
      return state;
  }
};

export default auth;
